import { render, staticRenderFns } from "./EventMods.vue?vue&type=template&id=8c3b39f2&"
import script from "./EventMods.vue?vue&type=script&lang=ts&"
export * from "./EventMods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardText,VTabItem})
